<lib-base-signal-input
  [label]="label()"
  [hint]="placeholder()"
  [showRequired]="showRequiredIndicator()"
  [showError]="showError()"
  [errorMessage]="errorMessage()"
  [disabled]="disabled()"
  [showExternalLabel]="true">

  <div input class="w-full">
    <lib-signal-text-field
      [value]="selectedAddress || ''"
      [placeholder]="placeholder()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (click)="openPicker()">
    </lib-signal-text-field>
  </div>

</lib-base-signal-input>
